import { anyOf, array, object, oneOf, record, ref, tuple } from './composite';
import { boolean, date, integer, nullProperty, number, string } from './primitives';

/**
 * Exports
 */
export * from './composite';
// export * from './primitives'; --> DO NOT EXPORT! Risk of circular references
export * from './union';

export const Type = {
    anyOf,
    array,
    boolean,
    date,
    number,
    integer,
    null: nullProperty,
    object,
    oneOf,
    record,
    ref,
    string,
    tuple,
};
